var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Team(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5A3 3 0 1 0 12 11 3 3 0 1 0 12 5zM19 7A2 2 0 1 0 19 11 2 2 0 1 0 19 7zM5 7A2 2 0 1 0 5 11 2 2 0 1 0 5 7zM12 13c-3.532 0-6 1.323-6 3.217V18c0 .552.448 1 1 1h10c.552 0 1-.448 1-1v-1.783C18 14.323 15.532 13 12 13zM18.545 13.013c-.003.008-.001.003-.004.011C19.473 13.878 20 14.963 20 16.217V17h2c.552 0 1-.448 1-1v-.783C23 13.819 20.927 12.877 18.545 13.013zM4 16.217c0-1.255.527-2.339 1.459-3.193-.003-.008-.001-.003-.004-.011C3.073 12.877 1 13.819 1 15.217V16c0 .552.448 1 1 1h2V16.217z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Team);
export default __webpack_public_path__ + "static/media/icons8-team.1034e8ee.svg";
export { ForwardRef as ReactComponent };